// import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import announcements from "@/frame/messages/mixins/announcements.js";
import moment from "moment";

export default {
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getUser", "getDetail", "getDetailSave", "getDetailStats"])
  },
  mixins: [dataSources, announcements],
  data() {
    return {
      valid: true
    };
  },
  methods: {
    setDocumentUpdating() {
      // INITIALISE
      let detail = this.getDetail;
      let did = detail.basic.did;
      let tag = detail.basic.tag;
      let db = this.defineDataSourceFromTag(tag);
      // console.log("");
      // console.log("SET DOC UPDATING");
      // console.log(did);
      // console.log(tag);
      // console.log(detail);
      // console.log(db);
      // SAVE UPDATE
      detail.basic.save = false;
      detail.rev.udid = this.getUser.basic.did;
      detail.rev.uname = this.getUser.basic.title;
      detail.rev.uemail = this.getUser.basic.email;
      detail.stats.dopen = moment().format();
      // FIREBASE UPDATE
      // eslint-disable-next-line
      db.doc(did).set(detail).then(() => {
          // Update Store
          this.$store.dispatch("changeDetail", detail);
          this.$store.dispatch("changeDetailSave", detail); // used for update
          this.$store.dispatch("changeDetailBasic", detail.basic);
          // DO NOT UNCOMMENT BELOW This OVERWRITES STATS DATA
          // this.$store.dispatch("changeDetailStats", detail.stats);
          this.btnSpinChangeSaveStatus = false;
          this.dialog = false;
          // eslint-disable-next-line
          // this.generateInfoSnackbar(this.ui.colorWarning, "Data save enabled.");
        });
    },
    setDocumentClosed() {
      console.log(this.getDetailSave);
      // INITIALISE
      let detail = this.getDetailSave;
      let did = detail.basic.did;
      let tag = detail.basic.tag;
      let db = this.defineDataSourceFromTag(tag);
      // SAVE UPDATE
      detail.basic.save = true; // enable saving
      // FIREBASE UPDATE
      // eslint-disable-next-line
      db.doc(did).set(detail).then(() => {
          // Update Store
          this.$store.dispatch("changeDetailSave", null); // used for update
          // eslint-disable-next-line
          // this.generateInfoSnackbar(ui.colorWarning, "Document was closed.");
        });
    }
  }
};
